import { SocialLink } from 'shared/interfaces';
import { SOCIAL_NETWORK_ICONS } from './social-network-icons';

export const EV_IO_SOCIAL_LINKS: SocialLink[] = [
  {
    label: 'Twitter',
    icon: SOCIAL_NETWORK_ICONS.twitter,
    link: 'https://twitter.com/play_evio',
  },
  {
    label: 'Discord',
    icon: SOCIAL_NETWORK_ICONS.discord,
    link: 'https://discord.gg/evio',
  },
  {
    label: 'Telegram',
    icon: SOCIAL_NETWORK_ICONS.telegram,
    link: 'https://t.me/playevio',
  },
  {
    label: 'Twitch',
    icon: SOCIAL_NETWORK_ICONS.twitch,
    link: 'https://www.twitch.tv/directory/game/ev.io',
  },
  {
    label: 'Instagram',
    icon: SOCIAL_NETWORK_ICONS.instagram,
    link: 'https://www.instagram.com/playevio',
  },
  {
    label: 'TikTok',
    icon: SOCIAL_NETWORK_ICONS.tiktok,
    link: 'https://www.tiktok.com/@play_evio',
  },
  {
    label: 'Website',
    icon: 'https://okletsplay.com/cdn/games/images/ev-io-icon.svg',
    link: 'https://ev.io',
  },
];
